// Central asset config — swap real URLs/clips here later without touching layout
// Each entry: { src?: string, caption: string, aspect?: string }
export const ASSETS = {
    // Founder portraits — Hero & About sections. Served from same-origin
    // /public/founders so the images always load (no dependency on third-party CDN,
    // no CORS or ad-blocker interference on the client side).
    founders: [
        { src: "/founders/founder1.png", caption: "FOUNDER 01", aspect: "aspect-square" },
        { src: "/founders/founder2.png", caption: "FOUNDER 02", aspect: "aspect-square" },
        { src: "/founders/founder3.png", caption: "FOUNDER 03", aspect: "aspect-square" },
    ],
    // Service preview loops — Services section (5 cards)
    servicePreviews: [
        { video: "/services/service-1.mp4", caption: "PREVIEW — PRODUCT STORIES" },
        { video: "/services/service-2.mp4", caption: "PREVIEW — LEARNING EXPERIENCES" },
        { video: "/services/service-3.mp4", caption: "PREVIEW — INTERNAL COMMS" },
        { video: "/services/service-4.mp4", caption: "PREVIEW — BRAND MOTION" },
        { video: "/services/service-5.mp4", caption: "PREVIEW — MOTION SYSTEMS" },
    ],
    // Before / After artifacts
    beforeAfter: [
        { before: "BEFORE — PDF", after: "AFTER — STORY" },
        { before: "BEFORE — PRODUCT DEMO", after: "AFTER — PRODUCT EXPERIENCE" },
        { before: "BEFORE — POLICY DOC", after: "AFTER — INTERACTIVE LEARNING" },
    ],
    // Stories In Motion case studies
    caseStudies: [
        {
            number: "01",
            client: "Harvard",
            frames: [
                { caption: "HARVARD — FRAME 01", video: "/case-studies/harvard-1.mp4" },
                { caption: "HARVARD — FRAME 02", video: "/case-studies/harvard-2.mp4" },
                { caption: "HARVARD — FRAME 03", video: "/case-studies/harvard-3.mp4" },
            ],
            blocks: {
                challenge: "Dense academic material wasn't landing with global learners.",
                strategy: "Translate research into motion-first narrative beats.",
                storyboard: "Six-act sequence mapped to learner attention curves.",
                motion: "Kinetic typography + spatial diagrams + restrained accent moments.",
                outcome: "3.2× lift in completion across cohorts.",
            },
        },
        {
            number: "02",
            client: "Emeritus",
            frames: [
                { caption: "EMERITUS — FRAME 01", video: "/case-studies/emeritus-1.mp4" },
                { caption: "EMERITUS — FRAME 02", video: "/case-studies/emeritus-2.mp4" },
                { caption: "EMERITUS — FRAME 03", video: "/case-studies/emeritus-3.mp4" },
            ],
            blocks: {
                challenge: "Course intros felt corporate and skippable.",
                strategy: "Lead with the learner's question, not the syllabus.",
                storyboard: "Hook → tension → reframe → invitation, in 35 seconds.",
                motion: "Soft glassmorphic frames, accent linework, calm pace.",
                outcome: "47% lift in qualified course starts.",
            },
        },
        {
            number: "03",
            client: "GMMCO",
            frames: [
                { caption: "GMMCO — FRAME 01", video: "/case-studies/gmmco-1.mp4" },
                { caption: "GMMCO — FRAME 02", video: "/case-studies/gmmco-2.mp4" },
            ],
            blocks: {
                challenge: "Heavy industrial product, hard to demo on a screen.",
                strategy: "Make the machine the protagonist; humans react.",
                storyboard: "Wide → detail → context → trust signal.",
                motion: "3D-feel parallax, metallic palette, single hero shot.",
                outcome: "Sales cycle shortened by 28%.",
            },
        },
        {
            number: "04",
            client: "Motion Experiments",
            frames: [
                { caption: "MOTION EXP — FRAME 01", video: "/case-studies/motion-1.mp4" },
                { caption: "MOTION EXP — FRAME 02", video: "/case-studies/motion-2.mp4" },
                { caption: "MOTION EXP — FRAME 03", video: "/case-studies/motion-3.mp4" },
            ],
            blocks: {
                challenge: "Our own playground — push motion as a system, not a clip.",
                strategy: "Build reusable motion tokens, test in public.",
                storyboard: "Daily R&D loops shared as 6-second studies.",
                motion: "Procedural, scroll-linked, performance-first.",
                outcome: "An always-on lab that feeds every client engagement.",
            },
        },
    ],
    // About floating grid
    aboutGrid: [
        { caption: "SKETCH 01" },
        { caption: "MOODBOARD 01" },
        { caption: "FRAME 01" },
        { caption: "FRAME 02" },
        { caption: "SKETCH 02" },
    ],
    // Free preview three-stage transform
    previewStages: [
        { caption: "ROUGH SKETCH" },
        { caption: "POLISHED FRAME" },
        { caption: "ANIMATED LOOP" },
    ],
};
